<template>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div>
        <div :class="getFrameSuperiorClass()">
            <div class="container">
                <div class="col-left">
                    <CalendarioSimplesComponent
                        :datasMarcadas="datasComEventos"
                        @mudouMes="setPeriodo"
                        @clicouData="selecionarData"
                    />
                </div>

                <div class="col-right">
                    <div v-if="lsDados.length>0" class="table-wrapper row-space">
                        <table>
                            <thead>
                                <tr>
                                    <th class="col-width-date">Data</th>
                                    <th class="col-width-char05">Hora</th>
                                    <th>Nome/Assunto</th>
                                    <th class="col-width-char20">Tipo</th>
                                    <th class="col-width-char30">Situação</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(obj, index) in lsDados" :key="obj.id"
                                    :class="getRowClass(index, obj.idstatus)"
                                    @click="setAgendaSelecionada(obj)"
                                >
                                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtagenda) }}</td>
                                    <td class="col-width-char05 center">{{ Funcoes.formatTimeFromJson(obj.hragenda) }}</td>
                                    <td>{{ [obj.nmpessoa, obj.assunto].filter(Boolean).join(' - ') || 'Informação indisponível' }}</td>
                                    <td class="col-width-char20">{{ obj.nmtipo }}</td>
                                    <td class="col-width-char30">{{ obj.nmstatus }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row-end">
                        <ToggleButton v-if="!agendaSelecionada && dataSelecionada === dataAtual"
                            v-model="ckPendentes"
                            label-true="PENDENTES"
                            label-false="TODOS"
                            label-caption=""
                            btnWidth="100px"
                        />
                        <button class="btn-small" @click="closeForm()">Retornar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-if="agendaSelecionada" class="form-edit-page">
        <div v-if="[2,3,4].includes(agendaSelecionada.idstatus)" class="row row-space">
            <div class="form-item">
                <label class="label-caption">Solicitação para {{ agendaSelecionada.nmpessoa }}:</label>
                <input type="text" v-model="edSolicitacao" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Prazo</label>
                <input type="date" v-model="edDataPrazo" />
            </div>

            <div class="form-item-char40"><GabineteDepartamentoSelect :setFirst="true" v-model:departamentoSelecionado="idDepartamento"/></div>

            <button class="btn-small" @click="incluiRequisicao()">Incluir</button>
            <button class="btn-small" @click="setAgendaSelecionada(null)">Fechar</button>
        </div>

        <div v-else class="row row-space">
            <div class="form-item">
                <label class="label-caption">Histórico de:</label>
                <div class="field-label">{{ agendaSelecionada.nmpessoa }}</div>
            </div>

            <button class="btn-small" @click="setAgendaSelecionada(null)">Fechar</button>
        </div>


        <div v-if="lsRequisicoes.length>0">
            <div class="table-wrapper"><table>
                <thead><tr>
                    <th>Histórico de Solicitações</th>
                    <th>Departamento</th>
                    <th>Data</th>
                    <th>Prazo</th>
                    <th>Dias</th>
                    <th>Atendimento</th>
                    <th>Situação</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsRequisicoes" :key="obj.id" :class="getRowClassSolicitacoes(index, obj.ttdias_aguardando)">
                        <td>{{ obj.solicitacao }}</td>
                        <td class="col-width-char40">{{ obj.nmdepartamento }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtsolicitacao) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                        <td class="col-width-char05 center" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                            {{ Funcoes.formatInteger(obj.ttdias_aguardando) }}</td>
                        <td class="col-width-char15 center">{{ obj.dhatendimento }}</td>
                        <td class="col-width-char15" :class="{ 'td-alert': obj.ttdias_aguardando < 0 }">
                            {{ obj.nmstatus }}</td>
                    </tr>
                </tbody>
            </table></div>
        </div>
        <div v-else>
            <h3>NENHUM HISTÓRICO DE REQUISIÇÃO</h3>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref, watch } from 'vue'
import { Api } from '@/funcoes/apiExport'
import { Funcoes } from '@/funcoes/utils'
import { globalStore } from '@/globals'
import CalendarioSimplesComponent from '@/components/CalendarioSimplesComponent.vue'
import GabineteDepartamentoSelect from '@/selects/GabineteDepartamentoSelect.vue'
import MensagemAlerta from '@/components/MensagemAlerta.vue'
import ToggleButton from '@/components/ToggleButton.vue'

const emit=defineEmits(['close']);


const auxAno=ref(0);
const auxMes=ref(0);
const msgAlerta=ref(null);
const lsDados = ref([]);
const datasComEventos = ref([]);
const dataSelecionada = ref(Funcoes.strDataAtual());
const dataAtual = ref(Funcoes.strDataAtual());


// NOVOS CONTROLES PARA AJUSTE AGENDA PREFEITO
const agendaSelecionada = ref(null);
const ckPendentes = ref(true);
const idDepartamento = ref(null);
const isLoading = ref(false);
const lsRequisicoes = ref([]);
const edDataPrazo = ref(Funcoes.dataAtual(30));
const edSolicitacao = ref(null);


function closeForm() {emit('close');}


function setAgendaSelecionada(obj){
    agendaSelecionada.value = obj;
    lerRequisicoes();
}


function setPeriodo({ mes, ano }){
    auxAno.value = ano;
    auxMes.value = mes;
    carregarEventos();
}


async function carregarEventos() {
    try{
        msgAlerta.value = null;
        const { datainicial, datafinal } = Funcoes.getIntervaloMes(auxMes.value, auxAno.value);
        const req = await Api.genericPost('/gabinete/agenda/datas_com_eventos', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: datainicial, 
            datafinal: datafinal
        });
        datasComEventos.value = req.map(item => item.dtagenda);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}


function getFrameSuperiorClass(){
    if (agendaSelecionada.value) return 'form-edit-page row-space';
    return 'form-edit-page';
}


function getRowClass(index, idstatus){
    if (idstatus === -1) return 'destaque-row clickabe-row';
    return index % 2 === 0 ? 'even-row clickabe-row' : 'odd-row clickabe-row';
}


function getRowClassSolicitacoes(index, ttdias){
    if (ttdias < -100000) return 'alert-row';
    return index % 2 === 0 ? 'even-row' : 'odd-row';
}


async function incluiRequisicao(){
    try {
        if (!edSolicitacao.value){throw new Error('Informe a solicitação')}
        Funcoes.validarData(edDataPrazo.value);
        if (!idDepartamento.value){throw new Error('Informe o departamento')}
        isLoading.value=true;
        msgAlerta.value=null;

        // INICIAR ATENDIMENTO CASO ESTEJA EM AGUARDO
        if ([2,3].includes(agendaSelecionada.value.idstatus)){
            const x = await Api.genericPost('/gabinete/agenda/atendimento/iniciar', {
                idmunicipio: globalStore.idmunicipio,
                id: agendaSelecionada.value.id,
                idlogin: globalStore.idlogin,
                idusuario: globalStore.idusuario});
            if (x.bolok!=1) {msgAlerta.value = x.erro; return;}
            agendaSelecionada.value.idstatus = 4;
            lerEventos();
        }

        const r = await Api.genericPut('/cad/gabinete_agenda_req', {
            idagenda: agendaSelecionada.value.id,
            idpessoa: agendaSelecionada.value.idgabinete_pessoa, //to-do: permitir selecionar quando usar lista
            iddepartamento: idDepartamento.value,
            dtsolicitacao: Funcoes.strDataAtual(),
            dtprazo: edDataPrazo.value,
            solicitacao: edSolicitacao.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok===1){
            await lerRequisicoes();
            edSolicitacao.value=null;
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function lerEventos() {
    try{
        msgAlerta.value = null;
        const req = await Api.genericPost('/listas/gabinete_agenda', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dataSelecionada.value, 
            datafinal: dataSelecionada.value});
        if (dataSelecionada.value === dataAtual.value && ckPendentes.value){
            lsDados.value=req.filter(item => [2,3,4].includes(item.idstatus));
        }else{
            lsDados.value=req;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`}
}


async function lerRequisicoes() {
    if (!agendaSelecionada.value) return;
    try{
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete_agenda_req', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: agendaSelecionada.value.idgabinete_pessoa});
        lsRequisicoes.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`}
}


async function selecionarData(data) {
    try{
        agendaSelecionada.value=null;
        dataSelecionada.value = Funcoes.formatDate(data);
        ckPendentes.value = true; // SEMPRE CHAMAR PRA QUANDO VOLTAR PRO "DIA" EXIBIR APENAS OS PENDENTES
        lerEventos();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}


onMounted(lerEventos);


watch(ckPendentes, (novoValor) => {
    console.log(novoValor);
    if (dataSelecionada.value === dataAtual.value){
        lerEventos();
    }
});
</script>



<style scoped>
.container {
    display: flex;
    gap: 1rem;
}
  
.col-left {
  width: 320px;
  max-width: 320px;
  flex-shrink: 0;
}
  
.col-right {
    flex: 1;
}
</style>  